import React from 'react';
import CheckboxGroup from './CheckboxGroup';
import WrapComponent from '../WrapComponent';
import './CheckboxGroup.less';

class CheckboxIndex extends React.Component{
    getChildOptions = ()=>{
        let parent = this.props.parent_node;
        let options = parent && parent.options;
        if (!options){
            return;
        }
        
        let {form, api_name, type} = this.props;
        let is_area_type = ['country', 'province', 'city', 'district'].indexOf(type) > -1;

        //父级选择的值
        let value = form.getFieldValue(parent.api_name);
        
        // 选择的选项
        let option = options.filter((item)=>{
            return item.value === value;
        });
        // 子选项
        let child_options = (option && option[0] && option[0].child_options) || [];
        
        let child = child_options.find((item)=>{
            if (is_area_type) {
                return item[type]
            }else {
                return item[api_name];
            }
        });

        if (is_area_type) {
            return child && child[type];
        }else {
            if(child && child[api_name] && child[api_name].length>0){
                child[api_name].forEach((item,i) => {
                    if(item == 'other'){
                        child[api_name].push(...child[api_name].splice(i,1))
                    }
                })
            }
            return child && child[api_name];
        }
    }
    parseOptions = ()=>{
        let optionsValue = this.getChildOptions()
        let props = this.props,opts;
        if(this.props.parent_node) {
            opts = optionsValue&&props.options&&(props.options.filter((item) => {
                if(optionsValue.indexOf(item.value) > -1) {
                    return item
                }
            })) || []
            if(!opts || opts.length<1) {
                opts = []
            }
        }else{
            opts = props.options;
        }
        return opts
    }

    getInitialValue = (opts,defaultValue) => {
        let val = []
        opts.forEach((item) => {
            if(defaultValue.indexOf(item.value) > -1) {
                val.push(item.value)
            }
        })
        return val
    }

    componentWillMount(){
        this.isFirstShow = true
    }

    render(){
        let props = this.props;
        let {parent_node, form} = props;
        const {getFieldProps} = props.form;
        let temp = {};
        //opts是真正传入多选的选项
        temp.opts = this.parseOptions();
        (temp.opts && temp.opts.length>0)?(temp.opts = temp.opts):[]
        let initialValue = this.getInitialValue(temp.opts || [],props.default_value || [])

        if(parent_node) {
            //父级的值
            let parentValue = form.getFieldValue(parent_node.api_name)||'';
            //父级默认的值
            let parentDefaultValue = parent_node.default_value||'';
            //第一次进来展示默认值，父级选项变动时，子级不再展示设置的默认值
            if(this.isFirstShow && parentValue != parentDefaultValue) {
                this.isFirstShow = false
            }
        } 
        temp.isFirstShow = this.isFirstShow;
        let fieldProps = getFieldProps(props.api_name, {
            initialValue: this.isFirstShow? initialValue : [],
            validate: [{
                trigger: 'onBlur',
                rules: [{
                    required: props.is_required, 
                    message: $st(`paas.smart.form.isrequired`) 
                }],
            }]
        });
        return (
            <CheckboxGroup {...props} {...fieldProps} {...temp}></CheckboxGroup>
        )
    }
    
}

export default WrapComponent(CheckboxIndex)



// WEBPACK FOOTER //
// ./src/component/CheckboxGroup/index.js